import {
  hasPermission,
  isAdmin,
} from "../../../../shared/components/layout/sidebar/utils/permissions.js";

export const UPLOAD_VIDEO_CAMPANHA_ROLE = "Upload Video Campanha";

/**
 * @param {Array<{name?: string, islist?: boolean, isinsert?: boolean}>|unknown} permissions
 * @param {"islist"|"isinsert"} action
 * @returns {boolean}
 */
export function hasUploadVideoCampanhaPermission(permissions, action) {
  if (!Array.isArray(permissions) || permissions.length === 0) {
    return false;
  }

  if (isAdmin(permissions)) {
    return true;
  }

  return hasPermission(permissions, UPLOAD_VIDEO_CAMPANHA_ROLE, action);
}

/** Decide se o usuário pode inserir, atualizar ou publicar o vídeo da campanha. */
export function canPublishSaleCampaign(permissions) {
  return hasUploadVideoCampanhaPermission(permissions, "isinsert");
}
